import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  email: Yup.string().email('Please provide a valid email.').required('The email field is required'),
});

export enum ToToggle {
  GeneralInfo,
  MobileOnlyInfo,
}